module.exports = __webpack_public_path__ + "static/img/8.0d96c7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/8.png
// module id = S/pp
// module chunks = 0